<template>
    <div class="feedback-area bg-6dbbbd pt-100 pb-70">
        <div class="container">
            <div class="section-title" v-for="title of titles" :key="title.title_id">
                <span class="sub-title">{{ title.title_title }}</span>
                <h2 class="font-weight-black">{{ title.title_header }}</h2>
                <p>{{ title.title_content }}</p>
            </div>
        </div>
        <div class="container-fluid">
            <div class="feedback-slides-three">
                <carousel :autoplay="5000" :settings='settings' :breakpoints='breakpoints' :wrap-around="true">
                    <Slide v-for="comment in comments" :key="comment.comment_id">
                        <div class="single-kindergarten-feedback-item">
                            <div class="content">
                                <img src="../../assets/img/shape/feedback-shape.png" alt="image">
                                <p>{{ comment.comment_message }}</p>
                            </div>
                            <div class="client-info">
                                <img src="../../assets/img/user/user9.png" alt="image">
                                <h3 class="font-weight-black">{{ comment.comment_name }}</h3>
                                <span>Veli</span>
                            </div>
                        </div>
                    </Slide>

                    <template #addons>
                        <Navigation />
                    </template>
                </carousel>
            </div>
        </div>
        <div class="kindergarten-shape13">
            <img src="../../assets/img/kindergarten-shape/k-shape13.png" alt="image">
        </div>
        <div class="kindergarten-shape14">
            <img src="../../assets/img/kindergarten-shape/k-shape14.png" alt="image">
        </div>
    </div>
</template>

<script>

import axios from "axios";


import { defineComponent } from 'vue';
import { Carousel, Slide, Navigation } from 'vue3-carousel';

import 'vue3-carousel/dist/carousel.css';

export default defineComponent({
    name: 'Feedback',
    props: ['pathUrl'],
    components: {
        Carousel,
        Slide,
        Navigation,
    },
    data: () => ({
        titles: [],
        comments: [{ "comment_id": 1, "comment_situation": 1, "comment_date": "2023-10-18 00:00:00", "comment_name": "Ali Veli", "comment_mail": "aliveli@gmail.com", "comment_phone": "5555555555", "comment_message": "Lorem ipsum dolor sit aadamet45, consectetur adipiscing elit elit3, sed do eiusmod tempor incididunt ut labore et dolore magna. Eiusmod incididunt." }],
        errors: [],

        settings: {
            itemsToShow: 1,
            snapAlign: 'center',
        },
        breakpoints: {
            0: {
                itemsToShow: 1,
                snapAlign: 'center',
            },
            576: {
                itemsToShow: 2,
                snapAlign: 'left',
            },
            768: {
                itemsToShow: 2,
                snapAlign: 'left',
            },
            992: {
                itemsToShow: 3,
                snapAlign: 'center',
            },
            1200: {
                itemsToShow: 4,
                snapAlign: 'left',
            },
        },
    }),
    created() {
        this.getTitles();
        this.getComments();
    },
    methods: {
        getTitles() {
            axios.get(this.pathUrl + "?data=title&parent=6")
                .then(response => (this.titles = response.data.result))
                .catch(error => {
                    this.errors.push(error);
                });
        },
        getComments() {
            axios.get(this.pathUrl + "?data=comment")
                .then(response => (this.comments = response.data.result))
                .catch(error => {
                    this.errors.push(error);
                });
        }
    }
})
</script>